import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@emotion/react";
// import theme from "./Theme/Theme";
import router from './Routes/Routes';
import theme from "./Theme/Theme";

function App() {
  return (  
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}
export default App;
